import { useCallback, useState } from "react";
import useJsonApi from "lib/useJsonApi.js";

function useUpdateAppointmentStatus(appointment) {
  const [request, setRequest] = useState({});

  const response = useJsonApi({
    url: request.url,
    method: "POST",
    body: request.body,
  });

  const updateStatus = useCallback(
    (status, comment) => {
      setRequest({
        url: `/api/appointment/${encodeURIComponent(
          appointment.appointmentUuid
        )}/update-status`,
        body: { status, comment },
      });
    },
    [appointment]
  );

  return [updateStatus, response];
}

export default useUpdateAppointmentStatus;
